import Service from '../abstract/service'

export default class Grupos extends Service {

  constructor() {
    super()

    this._gruposCollection = this._db.collection(`${this._prefix}-gruposEmpresas`)
  }

  async list() {
    let grupos = new Array()

    try
    {
      const response = await this._gruposCollection.get()
      if(!response.empty) {
        for(let doc of response.docs) {
          grupos.push({
            id: doc.id
          })
        }
      }
    }
    catch(error)
    {
      return Promise.reject(error)
    }

    return Promise.resolve(grupos)
  }

}
